<app-back-header
  [headerText]="'Torna alla dashboard'"
  (backAction)="backToDashboard()"
  class="sticky-top">
</app-back-header>

<h3 class="ms-2 mt-2">Dichiarazione dei redditi</h3>

<div class="ms-2 mt-2" *ngIf="!isLoading && incomeStatements.length > 0" >
  <p>La tua dichiarazione è pronta! Vedi i dettagli qui sotto.</p>
</div>

<!-- Loading State -->
<div *ngIf="isLoading" class="loading-container">
  <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
  <p class="mt-3">Caricando...</p>
</div>

<div *ngIf="!isLoading && incomeStatements.length === 0"
     class="d-flex vh90 w-100 flex-column justify-content-center align-items-center">
  <div class="col-11 d-flex justify-content-center align-items-center flex-column">
    <img mat-card-image class="col-md-3 col-9" src="izy_image_2.png" alt="Home image">
    <h5 class="mt-5">È ancora presto! Passa più tardi.</h5>
  </div>
</div>

<!-- Statement Cards -->
<div *ngIf="!isLoading && incomeStatements.length > 0" class="statements-list">
  <mat-card *ngFor="let statement of incomeStatements" class="statement-card" appearance="outlined">

    <!-- Header con icona e titolo -->
    <mat-card-header class="statement-header">
      <div mat-card-avatar class="statement-avatar">
        <mat-icon>description</mat-icon>
      </div>
      <mat-card-title>{{ statement.name }}</mat-card-title>
      <mat-card-subtitle>
        <mat-icon class="meta-icon">calendar_today</mat-icon>
        {{ statement.date | date:'dd MMMM yyyy' }}
      </mat-card-subtitle>
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content class="statement-content">

      <!-- Messaggio -->
      <p class="statement-message">{{ statement.message }}</p>

      <!-- Mittente -->
      <div class="meta-row">
        <mat-icon class="meta-icon">person_outline</mat-icon>
        <span class="meta-label">Mittente</span>
        <span class="meta-value">{{ statement.sender }}</span>
      </div>

    </mat-card-content>

    <!-- Allegato -->
    <mat-card-actions *ngIf="statement.attached_file" class="statement-actions" align="end">
      <button
        mat-flat-button
        class="open-attachment-btn"
        (click)="openAttachment(statement.attached_file)">
        <mat-icon>open_in_new</mat-icon>
        Apri Dichiarazione
      </button>
    </mat-card-actions>

  </mat-card>
</div>

<!-- Guida card (con dichiarazioni) -->
<mat-card
  *ngIf="!isLoading && incomeStatements.length > 0"
  class="mt-3 custom-card-blue"
  (click)="openGuide5Dialog()"
  >
    <mat-card-content class="p-0 m-2">
        <div class="card-body p-0">
          <div class="ms-2 mb-2 d-flex m-0 justify-content-between align-items-center">
            <p class="mb-0">Qualcosa non ti è chiaro?</p>
            <mat-icon class="me-1">help</mat-icon>
          </div>
          <div class="ms-2 mb-2">
            Consulta la nostra guida su Regime Forfettario e Scadenze fiscali.
          </div>
          <mat-card class="clickable-blue custom-card-blue">
            <mat-card-content class="p-0 m-1">
              <div class="ms-2 me-2 d-flex m-0 justify-content-between align-items-center">
                Apri la guida
                <mat-icon>open_in_full</mat-icon>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
    </mat-card-content>
</mat-card>

<!-- Guida card (senza dichiarazioni) -->
<mat-card
  *ngIf="!isLoading && incomeStatements.length === 0"
  class="mt-3 container custom-card-blue"
  (click)="openGuide5Dialog()"
  >
    <mat-card-content class="p-0 m-2">
        <div class="card-body p-0">
          <div class="ms-2 mb-2 d-flex m-0 justify-content-between align-items-center">
            <p class="mb-0">Qualcosa non ti è chiaro?</p>
            <mat-icon class="me-1">help</mat-icon>
          </div>
          <div class="ms-2 mb-2">
            Consulta la nostra guida su Regime Forfettario e Scadenze fiscali.
          </div>
          <mat-card class="clickable-blue custom-card-blue">
            <mat-card-content class="p-0 m-1">
              <div class="ms-2 me-2 d-flex m-0 justify-content-between align-items-center">
                Apri la guida
                <mat-icon>open_in_full</mat-icon>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
    </mat-card-content>
</mat-card>
